import { Box } from '@mui/material'
import SelectInput from '../../Common/SelectInput'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { useEffect, useRef, useState } from 'react'
import { updateLoader } from '../../../redux/slices/loaderSlice'
import {
    EntityInstancePath,
    updateEntityInstancePath,
    updateStartStep,
} from '../../../redux/slices/entityInstanceSlice'
import { EntityStepTypes } from '../../../constants/constants'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
export interface AvailableOrgList {
    id: string
    name: string
    templates: SelectedOrgTemplates[]
}

export interface SelectedOrgTemplates {
    id: string
    name: string
    mode?: string
}

const StartStep: React.FC = () => {
    const { t } = useTranslation()
    const userOrgId = useAppSelector((state) => state.org.org?.id)
    const availableOrgList = useAppSelector(
        (state) => state.entityInstance.availableOrgList,
    )
    const orgId = useAppSelector(
        (state) => state.entityInstance.startStep.orgId,
    )
    const instanceExistingOrgId = useAppSelector(
        (state) => state.entityInstance.startStep.instanceExistingOrgId,
    )
    const templateId = useAppSelector(
        (state) => state.entityInstance.startStep.templateId,
    )
    const parentTemplateName = useAppSelector(
        (state) => state.entityInstance.startStep.parentTemplateName,
    )

    const entitySteps = useAppSelector(
        (state) => state.entityInstance.entitySteps,
    )

    const entityAttributeStep = entitySteps?.find(
        (i) => i.stepType === EntityStepTypes.Attributes,
    )

    const dispatch = useAppDispatch()

    const [totalTemplates, setTotalTemplates] = useState<
        SelectedOrgTemplates[]
    >([])

    const isFirst = useRef(true)

    useEffect(() => {
        const setSubTemplateDetails = () => {
            const updatedTotalTemplates: SelectedOrgTemplates[] =
                availableOrgList.find((i) => i.id === orgId)?.templates || []
            setTotalTemplates(updatedTotalTemplates)
            isFirst.current = false
        }
        if (orgId && isFirst.current) {
            setSubTemplateDetails()
        }
    }, [orgId])

    const onChangeOrganization = (id: string, value: string) => {
        dispatch(updateLoader(true))

        // if (value !== orgId) {
        //     dispatch(updateEntitySteps([entitySteps[0]]))
        // }
        const updatedTotalTemplates: SelectedOrgTemplates[] =
            availableOrgList.find((i) => i.id === value)?.templates || []
        setTotalTemplates(updatedTotalTemplates)

        dispatch(
            updateStartStep({
                orgId: value,
                templateId: updatedTotalTemplates[0]?.id || '',
                templateName: updatedTotalTemplates[0]?.name || '',
            }),
        )
        changeEntityStepsByOrgIdAndTemplateId(
            value,
            updatedTotalTemplates[0]?.id || '',
            updatedTotalTemplates[0]?.name || '',
        )
    }

    const onChangeTemplate = (id: string, value: string) => {
        const getTemplateDetails: SelectedOrgTemplates = totalTemplates.find(
            (i) => i.id === value,
        ) || { id: '', name: '' }
        // if (value !== templateId) {
        //     dispatch(updateEntitySteps([entitySteps[0]]))
        // }
        if (getTemplateDetails) {
            dispatch(
                updateStartStep({
                    templateId: getTemplateDetails.id,
                    templateName: getTemplateDetails.name,
                }),
            )
            changeEntityStepsByOrgIdAndTemplateId(
                orgId,
                getTemplateDetails.id,
                getTemplateDetails.name,
            )
        }
    }

    const changeEntityStepsByOrgIdAndTemplateId = (
        orgId: string,
        templateId: string,
        templateName: string,
    ) => {
        const uniqueId = uuidv4()
        const path: EntityInstancePath = {
            pathId: uniqueId,
            pathName: parentTemplateName,
            activeStep: 0,
            orgId,
            templateId,
            templateName,
            relationId: templateId,
            relationName: templateName,
            entityId: entityAttributeStep?.instanceId || '',
            entityName: '',
            parentInstanceId: '',
            parentValues: {},
        }
        dispatch(
            updateEntityInstancePath({
                path: [path],
                isFirst: true,
                hasStartStep: true,
                resetAttributes: true,
            }),
        )
    }
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                marginRight: '20px',
            }}
        >
            <Box
                sx={{
                    width: 'calc(50%)',
                    marginBottom: '20px',
                    marginRight: '20px',
                }}
            >
                <SelectInput
                    label={t('program')}
                    id="subOrgList"
                    value={orgId}
                    onChange={onChangeOrganization}
                    list={availableOrgList || []}
                    hasEmpty={false}
                    required={true}
                    disabled={
                        !!orgId &&
                        userOrgId !== orgId &&
                        instanceExistingOrgId === orgId
                    }
                />
            </Box>

            <Box
                sx={{
                    width: 'calc(50%)',
                    marginBottom: '20px',
                }}
            >
                {totalTemplates?.length > 1 && (
                    <SelectInput
                        label={t('type')}
                        id="subtemplatesList"
                        value={templateId}
                        onChange={onChangeTemplate}
                        list={totalTemplates || []}
                        hasEmpty={false}
                        required={true}
                        disabled={
                            (!!orgId &&
                                userOrgId !== orgId &&
                                instanceExistingOrgId === orgId) ||
                            !!instanceExistingOrgId
                        }
                    />
                )}
            </Box>
        </Box>
    )
}

export default StartStep
